import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import Socket from "socket";
import CardSlider from "../components/CardSlider";
import chartImg from "assets/images/chpt/chart.png";
import {
  divVariants,
  bounce_right_to_left_variants,
  bounce_right_to_left_variants_delay_flip_out_x,flipinX_entry_flipinX_reversed_exit_bounceOutLeft
} from "shared/components/animations";
import { motion } from "framer-motion/dist/framer-motion";

const CHPTPlaying = ({
  isActivePlayer,
  roomId,isImageLoaded,
  currentPlayerCard,
  currentPlayer,
  prompt,
  setPlayerSelectedCard = () => {},
  buzzer_sound,
  default_audio_effect,
}) => {

  const setCardChoose = (card) => {
    setPlayerSelectedCard(card);
  };


  useEffect(() => {
    if (!isActivePlayer && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isActivePlayer, default_audio_effect]);

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="chpt-playing-container"
    >
     
          {isActivePlayer ? (
            <div className="active-playing">
              <motion.h3 variants={bounce_right_to_left_variants}>
                {" "}
                You’re Up
              </motion.h3>
              <motion.img
                variants={flipinX_entry_flipinX_reversed_exit_bounceOutLeft}
               
                className="chart-img"
                src={prompt.url}
                alt="chartImg"
              />
              <motion.h4 variants={bounce_right_to_left_variants}>
                Explain the chart aloud
              </motion.h4>
            </div>
          ) : (
            <>
              <motion.img
                variants={flipinX_entry_flipinX_reversed_exit_bounceOutLeft}
                className="chart-img"
                src={prompt.url}
                alt="chartImg"
              />
              <CardSlider
                currentPlayerCard={currentPlayerCard?.cards}
                showButton={true}
                selectCard={setCardChoose}
              />
            </>
          )}
       
    </motion.div>
  );
};

export default CHPTPlaying;
